import {Form, Formik, FormikProps, useFormik} from 'formik'
import React, {FC, useCallback, useEffect, useState} from 'react'
import {ICurrencyModel, initialCurrency, validationCurrency} from './CurrencyModel'
import {createCurrency, deleteCurrency, loadCurrencys, updateCurrency} from './Api'
import {showErrorToast, showSuccessToast} from '../../../../shared/components/ToastUtils'
import FormTabHeader, {TabOption} from '../../../../shared/components/FormTabHeader'
import TextInput from '../../../../shared/components/TextInput'
import {CurrencyTable} from './CurrencyTable'

const CurrencyPage: FC = () => {
  const [tab, setTab] = useState<string>('form')
  const [loading, setLoading] = useState(false)
  const [selectedId, setSelectedId] = useState<string | null | undefined>(null)
  const [showModal, setShowModal] = useState(false)
  const [controlSaveButton, setControlSaveButton] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [currency, setCurrency] = useState<ICurrencyModel[]>([])
  const [totalPages, setTotalPages] = useState(0)
  const [currentPage, setCurrentPage] = useState(0)

  const tabOptions: TabOption<'form'>[] = [
    {key: 'form', title: 'Döviz Tanımlama', icon: 'bi bi-geo-alt'},
  ]

  const fetchCurrency = useCallback(
    async (page: number = 0, sort?: string, order?: 'asc' | 'desc') => {
      setLoading(true)
      setError(null)
      try {
        const response = await loadCurrencys(page, 5, sort, order)
        if (response.data.hasError) {
          throw new Error(response.data.message || 'Failed to fetch currency')
        }
        setCurrency(response.data.payload.content)
        setTotalPages(response.data.payload.totalPages)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Unknown error occurred')
      } finally {
        setLoading(false)
      }
    },
    []
  )

  useEffect(() => {
    fetchCurrency(0)
  }, [fetchCurrency])

  const handleSave = async (values: ICurrencyModel, resetForm: () => void) => {
    setLoading(true)
    try {
      if (selectedId) {
        await updateCurrency({...values, id: selectedId})
        showSuccessToast('Döviz başarıyla güncellendi')
      } else {
        console.log(values)
        await createCurrency(values)
        showSuccessToast('Döviz başarıyla oluşturuldu')
      }
      await fetchCurrency(0)
      resetForm()
      setSelectedId(null)
      setTab('form')
    } catch (error) {
      showErrorToast('Bir hata oluştu')
    } finally {
      setLoading(false)
    }
  }

  const handleEdit = useCallback(
    (currency: ICurrencyModel, formik: FormikProps<ICurrencyModel>) => {
      formik.setValues(currency)
      setSelectedId(currency.id)
      setTab('form')
    },
    []
  )

  const handleDeleteClick = useCallback((currency: ICurrencyModel) => {
    setSelectedId(currency.id)
    setShowModal(true)
  }, [])

  const handleDelete = async (currency: ICurrencyModel) => {
    if (currency.id) {
      setLoading(true)
      try {
        await deleteCurrency(currency.id)
        showSuccessToast('Döviz başarıyla silindi')
        await fetchCurrency(currentPage)
      } catch (err) {
        console.error(err)
        showErrorToast('Döviz silinirken bir hata oluştu')
      } finally {
        setLoading(false)
        setShowModal(false)
        setSelectedId(null)
      }
    }
  }

  const handlePageChange = useCallback(
    (newPage: number) => {
      if (newPage >= 0 && newPage < totalPages) {
        setCurrentPage(newPage)
        fetchCurrency(newPage)
      }
    },
    [totalPages, fetchCurrency]
  )
  return (
    <>
      <Formik
        initialValues={initialCurrency}
        validationSchema={validationCurrency}
        enableReinitialize={true}
        onSubmit={(values, {resetForm}) => handleSave(values, resetForm)}
      >
        {(formik) => {
          const handleReset = () => {
            formik.resetForm()
            setSelectedId(null)
          }

          return (
            <>
              <FormTabHeader
                formId='currencyForm'
                formikSubmit={formik.handleSubmit}
                formikReset={handleReset}
                loading={loading}
                tab={tab}
                setTab={setTab}
                setSelectedId={setSelectedId}
                tabs={tabOptions}
                onExportExcel={() => console.log('Excel export')}
              />
              {tab === 'form' && (
                <div className='card mb-5'>
                  <Form id='currencyForm' className='form card-body'>
                    <div className='row mb-6'>
                      <TextInput
                        name='currencyAbbreviation'
                        label='Döviz Kısaltması'
                        placeholder='Döviz Kısaltması'
                        wrapperClassName='col-md-6'
                      />
                      <TextInput name='exchangeRate' label='Kur' wrapperClassName='col-md-6' />
                      <TextInput name='country' label='Ülke' wrapperClassName='col-md-6' />
                    </div>
                  </Form>
                </div>
              )}
              <div className='card'>
                <div className='card-body pt-0'>
                  <CurrencyTable
                    data={currency}
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                    onEdit={(vehicleGroup) => handleEdit(vehicleGroup, formik)}
                    onDelete={handleDelete}
                    loading={loading}
                  />
                </div>
              </div>
            </>
          )
        }}
      </Formik>
    </>
  )
}

export {CurrencyPage}
